import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CircleIcon from '@mui/icons-material/Circle';

function HealthBehaviorSurveyResults() {
    const navigate = useNavigate()
    const location = useLocation()
    const [evaluation, setEvaluation] = useState([])
    const [weight, setWeight] = useState('')
    const [height, setHeight] = useState('')

    useEffect(() => {
        // console.log(location.state.information)
        setEvaluation(location.state.information)
        setHeight(location.state.height)
        setWeight(location.state.weight)
    }, [])


    return (
        <>
            <Box>
                <Box sx={{ display: 'grid', gridGap: '10px' }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px',
                    }}>
                        <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                        <Box sx={{
                            cursor: 'pointer'
                        }}
                            onClick={() => { navigate('/healthBehaviorSurvey') }}
                        >กลับไป แบบประเมินสุขภาพ</Box>
                    </Box>

                    <Box
                        sx={{
                            fontWeight: 600,
                            color: "#478F96",
                            "@media (max-width: 800px)": {
                                textAlign: "center",
                            },
                        }}
                    >
                        แบบสำรวจพฤติกรรมสุขภาพกำลังพล สป. ปี พศ. 2568
                    </Box>

                    <Typography sx={{ fontWeight: 600 }}>ผลการประเมิน</Typography>

                    <Box>
                        <Box sx={{ color: "#478F96" }}>ส่วนที่ 1 : ข้อมูลทั่วไป</Box>
                        <Box
                            sx={{
                                border: "1px solid #AEB4DD",
                                borderRadius: "5px",
                                padding: "20px",
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}
                        >
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr',
                                alignItems: 'center'
                            }}>
                                <Typography sx={{ fontWeight: 600 }}>น้ำหนัก</Typography>
                                <Box sx={{ backgroundColor: '#D9D9D9', borderRadius: '10px', padding: '10px' }}>{weight}</Box>
                            </Box>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr',
                                alignItems: 'center'
                            }}>
                                <Typography sx={{ fontWeight: 600 }}>ส่วนสูง</Typography>
                                <Box sx={{ backgroundColor: '#D9D9D9', borderRadius: '10px', padding: '10px' }}>{height}</Box>
                            </Box>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr',
                                alignItems: 'center'
                            }}>
                                <Typography sx={{ fontWeight: 600 }}>BMI</Typography>
                                <Box sx={
                                    evaluation['part1']?.['bmi']?.['result'] === "น้ำหนักต่ำกว่าเกณฑ์" ? { backgroundColor: '#FDFDAD', borderRadius: '10px', padding: '10px' }
                                        : evaluation['part1']?.['bmi']?.['result'] === "สมส่วน" ? { backgroundColor: '#D8EFB3', borderRadius: '10px', padding: '10px' }
                                            : evaluation['part1']?.['bmi']?.['result'] === "น้ำหนักเกิน" ? { backgroundColor: '#FDFDAD', borderRadius: '10px', padding: '10px' }
                                                : evaluation['part1']?.['bmi']?.['result'] === "โรคอ้วน" ? { backgroundColor: '#FCE3BE', borderRadius: '10px', padding: '10px' }
                                                    : { backgroundColor: '#FCBEBE', borderRadius: '10px', padding: '10px' }
                                } >{evaluation['part1']?.['bmi']?.['value'] + ' (' + evaluation['part1']?.['bmi']?.['result'] + ')'}</Box>
                            </Box>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr',
                                alignItems: 'center'
                            }}>
                                <Typography sx={{ fontWeight: 600 }}>รอบเอว</Typography>
                                <Box sx={
                                    evaluation['part1']?.['waist']?.['result'] === 'รอบเอวปกติ' ? { backgroundColor: '#D8EFB3', borderRadius: '10px', padding: '10px' }
                                        : { backgroundColor: '#FDFDAD', borderRadius: '10px', padding: '10px' }
                                } >{evaluation['part1']?.['waist']?.['value'] + ' (' + evaluation['part1']?.['waist']?.['result'] + ')'}</Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ color: "#478F96" }}>ส่วนที่ 2 : ข้อมูลสุขภาพ</Box>
                        <Box
                            sx={{
                                border: "1px solid #AEB4DD",
                                borderRadius: "5px",
                                padding: "20px",
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '10px'
                                },
                            }}
                        >
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr',
                                alignItems: 'center',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr 2fr'
                                },
                            }}>
                                <Typography sx={{ fontWeight: 600 }}>โรคประจำตัว</Typography>
                                <Box sx={{ backgroundColor: '#D9D9D9', borderRadius: '10px', padding: '10px' }}>{evaluation['part2']?.['condition']?.['answer']}</Box>
                            </Box>
                            <Box></Box>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr',
                                alignItems: 'center',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr 2fr'
                                },
                            }}>
                                <Box></Box>
                                <FormGroup>
                                    {evaluation['part2']?.['condition']?.['answer2'].map((i, idx) => (
                                        <FormControlLabel key={idx} control={<Checkbox defaultChecked onClick={(e) => e.preventDefault()} />} label={i} />
                                    ))}
                                    {evaluation['part2']?.['condition']?.['remark'] === '' ?
                                        null
                                        :
                                        <FormControlLabel control={<Checkbox defaultChecked onClick={(e) => e.preventDefault()} />} label={evaluation['part2']?.['condition']?.['remark']} />
                                    }
                                </FormGroup>
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ color: "#478F96" }}>ส่วนที่ 3 : ข้อมูลพฤติกรรมสุขภาพ</Box>
                        <Box
                            sx={{
                                border: "1px solid #AEB4DD",
                                borderRadius: "5px",
                                padding: "20px",
                                display: 'grid',
                                gridGap: '20px'
                            }}
                        >
                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px', fontWeight: 600 }}>
                                    <CircleIcon sx={{ width: '5px' }} />
                                    ท่านมีการขยับร่างกายจนเหนื่อยกว่าปกติ (รวมการทำงาน การเดินทาง การประกอบอาชีพ กิจกรรมเพื่อความบันเทิง และการออกกำลังกาย) โดยรวมเป็นเวลาเท่าใดใน 1 สัปดาห์
                                </Box>
                                <Box sx={{ color: '#478F96', marginLeft: '10px' }}>{evaluation['part3']?.['result_evaluate_q3_3']?.['result']}</Box>
                                <Box sx={{ marginLeft: '10px' }}>{evaluation['part3']?.['result_evaluate_q3_3']?.['recommend']}</Box>
                            </Box>
                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px', fontWeight: 600 }}>
                                    <CircleIcon sx={{ width: '5px' }} />
                                    ใน 1 สัปดาห์ที่ผ่านมา ท่านนั่งหรือเอนกายติดต่อกันนาน 2 ชม.ขึ้นไป โดยไม่รวมการนอนหลับ คิดเป็นกี่วันใน 1 สัปดาห์
                                </Box>
                                <Box sx={{ color: '#478F96', marginLeft: '10px' }}>{evaluation['part3']?.['result_evaluate_q3_4']?.['result']}</Box>
                                <Box sx={{ marginLeft: '10px' }}>{evaluation['part3']?.['result_evaluate_q3_4']?.['recommend']}</Box>
                            </Box>
                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px', fontWeight: 600 }}>
                                    <CircleIcon sx={{ width: '5px' }} />
                                    ใน 1 สัปดาห์ ท่านกินอาหารกลุ่มผักวันละ 5 ทัพพี (1 ทัพพีเท่ากับ 3 ช้อนกินข้าว) บ่อยครั้งเพียงใด
                                </Box>
                                <Box sx={{ color: '#478F96', marginLeft: '10px' }}>{evaluation['part3']?.['result_evaluate_q3_5']?.['result']}</Box>
                                <Box sx={{ marginLeft: '10px' }}>{evaluation['part3']?.['result_evaluate_q3_5']?.['recommend']}</Box>
                            </Box>

                            <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>

                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px', fontWeight: 600 }}>
                                    <CircleIcon sx={{ width: '5px' }} />
                                    พฤติกรรมการบริโภค หวาน มัน เค็ม
                                </Box>

                                {evaluation['part3']?.['result_evaluate_q3_6'].map((i, idx) => (
                                    <Box sx={{
                                        display: 'grid'
                                    }}>
                                        <Box sx={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gridGap: '10px',
                                            "@media (max-width: 800px)": {
                                                gridTemplateColumns: '1fr',
                                                gridGap: '10px'
                                            },
                                        }}>
                                            <Box sx={{
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 3fr',
                                                alignItems: 'center',
                                                "@media (max-width: 1300px)": {
                                                    gridTemplateColumns: '1fr 2fr'
                                                },
                                                "@media (max-width: 800px)": {
                                                    gridTemplateColumns: '1fr 1fr'
                                                },
                                            }} key={idx}>
                                                <Typography sx={{ fontWeight: 600 }}>{i['type']}</Typography>
                                                <Box sx={
                                                    i['result'] === 'เหมาะสม' ? { backgroundColor: '#D8EFB3', borderRadius: '10px', padding: '10px' }
                                                        : i['result'] === 'เสี่ยงปานกลาง' ? { backgroundColor: '#FDFDAD', borderRadius: '10px', padding: '10px' }
                                                            : i['result'] === 'เสี่ยงสูง' ? { backgroundColor: '#FCE3BE', borderRadius: '10px', padding: '10px' }
                                                                : i['result'] === 'เสี่ยงสูงมาก' ? { backgroundColor: '#FCBEBE', borderRadius: '10px', padding: '10px' }
                                                                    : { backgroundColor: '#D9D9D9', borderRadius: '10px', padding: '10px' }
                                                }>{i['result'] ? i['result'] : 'ไม่พบข้อมูล'}</Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ color: '#252641',margin: '5px 0' }}>{i['recommend']}</Box>
                                    </Box>
                                ))}



                            </Box>

                        </Box>
                    </Box>

                    <Box sx={{ textAlign: 'center' }}>
                        <Button variant='contained' onClick={() => { navigate('/assessment') }}>กลับหน้าหลัก</Button>
                    </Box>

                </Box>
            </Box>
        </>
    )
}

export default HealthBehaviorSurveyResults
